export class TransactionComparabilityParameters {
  public static ECONOMIC_ANALYSIS_SIMILARITY = 'economicAnalysisSimilarity';
  public static FUNCTIONAL_ANALYSIS_SIMILARITY = 'functionalAnalysisSimilarity';
  public static CONTRACTUAL_TERMS_SIMILARITY = 'contractualTermsSimilarity';
}
